module.exports = __webpack_public_path__ + "media/images/posts/piggy-bank-46c901162a26c5e0ad03b3abcc1e4a11.jpg";